import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p490689399966863360',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
